import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// Components
import EditNoteIcon from 'dibs-vg/dist/react/note-edit';
import BlankNoteIcon from 'dibs-vg/dist/react/note-blank';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles/Note.scss';

class Note extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showBlankNoteIcon: true,
        };

        this.swapIcons = this.swapIcons.bind(this);
    }

    swapIcons({ showBlankNoteIcon = false }) {
        this.setState({ showBlankNoteIcon });
    }

    render() {
        const noteClasses = classnames(styles.note, styles.edit, {
            [styles.disabled]: this.props.disabled,
            [styles.gridView]: !this.props.isListView,
        });

        const addNoteClasses = classnames(styles.note, styles.add, {
            [styles.disabled]: this.props.disabled,
            [styles.gridView]: !this.props.isListView,
        });

        const noteContentClasses = classnames(styles.noteContent, {
            [styles.gridView]: !this.props.isListView,
        });

        if (this.props.hasExistingNote) {
            return (
                <div
                    data-tn="note-preview"
                    className={noteClasses}
                    onMouseLeave={() => this.swapIcons({ showBlankNoteIcon: true })}
                    onMouseOver={() => this.swapIcons({ showBlankNoteIcon: false })}
                    onClick={this.props.onClick}
                >
                    {this.state.showBlankNoteIcon ? (
                        <BlankNoteIcon className={styles.icon} />
                    ) : (
                        <EditNoteIcon className={styles.icon} />
                    )}
                    <span className={noteContentClasses}>{this.props.noteContent}</span>
                </div>
            );
        } else if (!this.props.isPublic) {
            return (
                <div className={addNoteClasses} data-tn="note-link" onClick={this.props.onClick}>
                    <BlankNoteIcon className={styles.icon} />
                    <div className={noteContentClasses}>
                        <FormattedMessage
                            id="portfolio.listView.add_note"
                            defaultMessage="Add Note"
                        />
                    </div>
                </div>
            );
        }
        return null;
    }
}

Note.defaultProps = {
    noteContent: '',
    isPublic: false,
    isListView: false,
};

Note.propTypes = {
    disabled: PropTypes.bool,
    hasExistingNote: PropTypes.bool,
    noteContent: PropTypes.string,
    onClick: PropTypes.func,
    selecting: PropTypes.bool,
    isPublic: PropTypes.bool,
    isListView: PropTypes.bool,
};

export default Note;
